import { render, staticRenderFns } from "./ProdutosLista.vue?vue&type=template&id=3b7786e0&scoped=true&"
import script from "./ProdutosLista.vue?vue&type=script&lang=js&"
export * from "./ProdutosLista.vue?vue&type=script&lang=js&"
import style0 from "./ProdutosLista.vue?vue&type=style&index=0&id=3b7786e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7786e0",
  null
  
)

export default component.exports